import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Select, { components } from "react-select";

import { Listbox, Transition } from "@headlessui/react";
import axios from "axios";
import PropTypes from "prop-types";

import { LayoutContext, ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FiChevronDown } from "components/atoms/Icon/fi/FiChevronDown";
import { FiSearch } from "components/atoms/Icon/fi/FiSearch";
import Img from "components/atoms/Img";
import {
  InputEmail,
  InputPhone,
  InputText,
} from "components/atoms/Input/index";
import ReCaptcha from "components/atoms/Recaptcha/index";

import styles from "./Index.module.scss";

const Dropdown = ({ children, isOpen, target, onClose, ...props }) => (
  <div
    className={`relative bg-bbc-white ${props.className && props.className}`}
  >
    {target}
    {isOpen ? (
      <div
        className="absolute z-20 w-full rounded-sm bg-bbc-white pt-2 shadow-lg"
        style={{ height: "70px" }}
      >
        {children}
      </div>
    ) : null}
    {isOpen ? (
      <div
        className="fixed bottom-0 left-0 top-0 right-0 z-10"
        onClick={onClose}
      />
    ) : null}
  </div>
);

const IconSearch = () => <FiSearch className=" mr-2 text-bbc-neutral-700" />;
const CustomOption = (props) => (
  <components.Option {...props}>
    <div className="flex cursor-pointer items-center">
      {props.data.icon && (
        <Img
          style={{ marginRight: 8, width: 25, height: 18 }}
          src={`${props.data.icon.toLowerCase()}.svg`}
          alt={`${props.data.name.toLowerCase()}`}
        />
      )}
      <span className="text-sm">{props.data.name || props.data.label}</span>
    </div>
  </components.Option>
);

// Styled components
const customSelectStylesPhoneCode = {
  control: (base) => ({
    ...base,
    height: 42,
    minHeight: 42,
    fontSize: "14px",
    margin: "0 8px",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
  }),
};

//* Dropdown Select - END */

const Component = ({ description, descriptionClass }) => {
  const { locationRouter } = useContext(LayoutContext);
  const { openAlert } = useContext(ToastContext);
  // Const toast = useToast(3000);
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    setValue,
    formState: { isSubmitting, isSubmitted, isSubmitSuccessful, errors },
  } = useForm();

  const countryList = [
    { id: 8, label: "Anguilla", value: "Anguilla", flagSrc: "ai" },
    { id: 17, label: "Bahamas", value: "Bahamas", flagSrc: "bs" },
    { id: 23, label: "Belize", value: "Belize", flagSrc: "bz" },
    {
      id: 32,
      label: "British Virgin Islands",
      value: "British Virgin Islands",
      flagSrc: "vg",
    },
    { id: 41, label: "Cayman Islands", value: "Cayman Islands", flagSrc: "ky" },
    { id: 58, label: "Cyprus", value: "Cyprus", flagSrc: "cy" },
    { id: 250, label: "Delaware", value: "Delaware", flagSrc: "us" },
    { id: 98, label: "Hong Kong", value: "Hong Kong", flagSrc: "hk" },
    { id: 111, label: "Jersey", value: "Jersey", flagSrc: "je" },
    {
      id: 136,
      label: "Marshall Islands",
      value: "Marshall Islands",
      flagSrc: "mh",
    },
    { id: 139, label: "Mauritius", value: "Mauritius", flagSrc: "mu" },
    { id: 169, label: "Panama", value: "Panama", flagSrc: "pa" },
    { id: 183, label: "Samoa", value: "Samoa", flagSrc: "ws" },
    { id: 189, label: "Seychelles", value: "Seychelles", flagSrc: "sc" },
    { id: 191, label: "Singapore", value: "Singapore", flagSrc: "sg" },
    {
      id: 205,
      label: "St. Kitts & Nevis",
      value: "St. Kitts & Nevis",
      flagSrc: "kn",
    },
    {
      id: 209,
      label: "St. Vincent & Grenadines",
      value: "St. Vincent & Grenadines",
      flagSrc: "vc",
    },
    {
      id: 236,
      label: "Ras Al Khaimah (UAE)",
      value: "Ras Al Khaimah (UAE)",
      flagSrc: "ae",
    },
    {
      id: 237,
      label: "United Kingdom",
      value: "United Kingdom",
      flagSrc: "gb",
    },
    { id: 244, label: "Vietnam", value: "Vietnam", flagSrc: "vn" },
  ];

  const IncorporationOptions = [
    { value: "Incorporation Service", label: "Incorporation Service" },
    { value: "Bank account support", label: "Bank account support" },
    { value: "Virtual office", label: "Virtual office" },
    { value: "Legal ancillary service", label: "Legal ancillary service" },
    { value: "Accounting and auditing", label: "Accounting and auditing" },
    { value: "Others", label: "Others" },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState("");
  const [phoneCodeList, setPhoneCodeList] = useState([]);
  const [country, setCountry] = useState();
  const [countries] = useState(countryList);
  const [service, setService] = useState(IncorporationOptions[0]);
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  // Const filterPhoneCodes =
  //   String(phoneCountry) === ""
  //     ? phoneCodeList.slice()
  //     : phoneCodeList.filter((item) =>
  //         Item.label
  //           .toLowerCase()
  //           .replace(/\s+/g, "")
  //           .includes(String(phoneCountry).toLowerCase().replace(/\s+/g, ""))
  //       );

  const recaptchaRef = useRef();

  // Static_data country

  useEffect(() => {
    axios
      .get(
        `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/country`
      )
      .then((result) => {
        const phoneList = result?.data?.data
          ?.filter((item) => item.is_country === 1)
          .map((item) => ({
            label: `${item.country_code} +${item.phone_code}`,
            value: item.id,
          }));

        setPhoneCodeList(phoneList);
      });
  }, []);

  // Data geoLooking
  useEffect(() => {
    axios
      .get(
        `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/helper/geoLooking`
      )
      .then((result) => {
        setPhoneCountry(result?.data?.data?.id);
      });
  }, []);

  // Get phoneCountry
  const handleChangePhoneCountry = (newValue) => {
    setValue("phone_country_id", newValue?.value, { shouldValidate: true });
    setPhoneCountry(newValue?.value);
  };

  const onSelectCountryChange = (newCountry) => {
    setValue("country_id", newCountry.id, { shouldValidate: true });
    setCountry(newCountry);
  };
  const onSelectSubjectChange = (subject) => {
    setValue("subject", subject?.value, { shouldValidate: true });
  };

  const onSubmit = async (data) => {
    const dataSend = { ...data };

    dataSend.subject = service.value;
    dataSend.phone_country_id = phoneCountry;

    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();

      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;

      const formData = {
        first_name: dataSend.first_name,
        last_name: dataSend.last_name,
        email: dataSend.email,
        country_id: dataSend.country_id,
        phone_country_id: dataSend.phone_country_id,
        phone_number: dataSend.phone_number,
        subject: dataSend.subject,
        message: dataSend.message,
        client_id: dataSend.client_id,
        website_id: dataSend.website_id,
      };

      axios
        .post(
          `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form`,
          formData,
          {
            headers: {
              "captcha-response": token,
            },
          }
        )
        .then((response) => {
          trigger("contact_form", formData, "Contact form");
          if (response.data.state) {
            reset();
            clearErrors();
            setCountry(null);
            setService(IncorporationOptions[0]);
            openAlert(3000, "success");
            // Toast("success", "We'll contact you all right away");
          } else {
            openAlert(3000, "error");
            // Toast(
            //   "error",
            //   "Please check your network connection and try again"
            // );
          }
          setIsLoading(false);
        })
        .catch(() => {
          clearErrors();
          openAlert(3000, "error");
          // Toast("error", "Please check your network connection and try again");
          // Console.log(error);
        });
    } else {
      setIsLoading(false);
    }
  };

  const renderCountryListbox = () => {
    let listCountryFiltered = [...countries];

    if (locationRouter === "offshore") {
      listCountryFiltered = countries.filter(
        (item) => !["Hong Kong", "Singapore", "Vietnam"].includes(item.value)
      );
    }

    return listCountryFiltered.map((item, itemIdx) => (
      <Listbox.Option key={itemIdx} value={item} className="list-none">
        <div
          className={`flex cursor-pointer items-center gap-x-3 p-2 font-medium ${
            country?.label === item.label
              ? "bg-bbc-primary text-white"
              : "hover:bg-bbc-primary hover:bg-opacity-40"
          }`}
          onClick={() => setCountry(item)}
        >
          {item?.flagSrc && (
            <Img
              src={`/assets/flags/1x1/${item.flagSrc}.svg`}
              width={24}
              height={24}
              className="min-h-[24px] min-w-[24px] rounded-full"
              alt={item.flagSrc}
            />
          )}
          <span className="truncate">{item.label}</span>
        </div>
      </Listbox.Option>
    ));
  };

  return (
    <div className={`${styles.wrapper}`}>
      <p className={`${descriptionClass ? descriptionClass : "mb-6 lg:mb-10"}`}>
        {description}
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-6">
          <InputText
            register={register}
            errors={errors}
            name="first_name"
            placeholder="First Name*"
            requiredText={"First Name is required"}
          />
        </div>
        <div className="mb-6">
          <InputText
            register={register}
            errors={errors}
            name="last_name"
            placeholder="Last Name*"
            requiredText={"Last Name is required"}
          />
        </div>
        <div className="mb-6">
          <InputEmail register={register} errors={errors} />
        </div>
        <div className="mb-6">
          <Listbox
            as="div"
            value={country}
            onChange={onSelectCountryChange}
            className="relative   w-full border-0 border-b border-b-gray-300 pl-2"
            style={{ height: "42px" }}
          >
            {({ open }) => (
              <>
                <Listbox.Button
                  as="div"
                  role="button"
                  className="relative h-full w-full select-none pr-9 text-left focus:outline-0"
                >
                  <div className="flex items-center gap-x-2 pb-4">
                    {country?.flagSrc && (
                      <Img
                        src={`/assets/flags/1x1/${country.flagSrc}.svg`}
                        width={24}
                        height={24}
                        className="min-h-[24px] min-w-[24px] rounded-full"
                        alt={country.flagSrc}
                      />
                    )}
                    {country?.label ? (
                      <span className="truncate tracking-[0.25px] text-bbc-gray">
                        {country?.label}
                      </span>
                    ) : (
                      <span className="truncate tracking-[0.25px] text-gray-300">
                        Country of interest*
                      </span>
                    )}

                    <FiChevronDown
                      className={`absolute right-4 top-1/3 float-right -translate-y-1/2 transform align-middle text-bbc-gray ${
                        open ? "rotate-180" : "rotate-0"
                      } transition-all duration-200`}
                      size={24}
                    />
                  </div>
                </Listbox.Button>
                <Transition
                  show={open}
                  leave="transition-all duration-200 ease-out"
                  leaveFrom="transform opacity-50"
                  leaveTo="transform opacity-0"
                  className="absolute z-10 mt-2 w-full"
                >
                  <div className="overflow-hidden rounded-md shadow-md">
                    <Listbox.Options className="max-h-60 overflow-auto bg-white focus:outline-none">
                      {renderCountryListbox()}
                    </Listbox.Options>
                  </div>
                </Transition>
              </>
            )}
          </Listbox>
          {!country && isSubmitted && !isSubmitSuccessful && (
            <span className="block pt-2 text-sm text-red-500">
              Country is required
            </span>
          )}
        </div>
        <div className="mb-6 flex flex-col items-stretch space-y-6 lg:flex-row lg:space-y-0">
          <Dropdown
            isOpen={isOpenDropdown}
            onClose={() => setIsOpenDropdown(!isOpenDropdown)}
            className="w-full lg:mr-2 lg:w-2/5"
            target={
              <div
                role="button"
                className="relative block h-10 w-full cursor-pointer border-b border-gray-300 bg-bbc-white px-2 py-2"
                onClick={() => setIsOpenDropdown(!isOpenDropdown)}
              >
                {phoneCodeList &&
                phoneCodeList.find((item) => item.value === phoneCountry) ? (
                  <div className="flex items-center">
                    <span className="text-sm text-[#888]">
                      {
                        phoneCodeList.find(
                          (item) => item.value === phoneCountry
                        ).label
                      }
                    </span>
                  </div>
                ) : (
                  "Select..."
                )}
                <FiChevronDown
                  className={`absolute bottom-1/4 right-4 ${
                    isOpenDropdown ? "rotate-180" : "rotate-0"
                  } transition-all duration-200`}
                  size={24}
                />
              </div>
            }
          >
            <Select
              autoFocus
              className={styles.customSelectSearch}
              backspaceRemovesValue={false}
              controlShouldRenderValue={false}
              hideSelectedOptions={false}
              isClearable={false}
              menuIsOpen
              options={phoneCodeList}
              placeholder="Search..."
              tabSelectsValue={false}
              value={
                phoneCodeList &&
                phoneCodeList.find((item) => item.value === phoneCountry)
              }
              styles={customSelectStylesPhoneCode}
              components={{
                Option: CustomOption,
                IndicatorSeparator: () => null,
                DropdownIndicator: IconSearch,
              }}
              onChange={handleChangePhoneCountry}
            />
          </Dropdown>
          <div className="hidden items-start lg:flex">
            <div className="bottom-4 h-10 w-[1px] rounded-full bg-slate-300" />
          </div>
          <div className="w-full">
            <InputPhone
              register={register}
              errors={errors}
              name="phone_number"
              placeholder="Phone Number*"
            />
          </div>
        </div>
        <div className="mb-6">
          <Listbox
            as="div"
            value={service}
            onChange={onSelectSubjectChange}
            className="relative  w-full border-0 border-b border-b-gray-300"
            style={{ height: "42px" }}
          >
            {({ open }) => (
              <>
                <Listbox.Button
                  as="div"
                  role="button"
                  className="relative h-full w-full select-none pr-9 text-left focus:outline-0"
                >
                  <div className="flex items-center gap-x-2">
                    <span className="truncate tracking-[0.25px] text-bbc-gray">
                      {service.label}
                    </span>
                    <FiChevronDown
                      className={`absolute right-4 top-1/3 float-right -translate-y-1/2 transform align-middle text-bbc-gray  ${
                        open ? "rotate-180" : "rotate-0"
                      } transition-all duration-200`}
                      size={24}
                    />
                  </div>
                </Listbox.Button>
                <Transition
                  show={open}
                  leave="transition-all duration-200 ease-out"
                  leaveFrom="transform opacity-50"
                  leaveTo="transform opacity-0"
                  className="absolute z-10 mt-2 w-full"
                >
                  <div className="overflow-hidden rounded-md shadow-md">
                    <Listbox.Options className="max-h-60 overflow-auto bg-white focus:outline-none">
                      {IncorporationOptions.map((item, itemIdx) => (
                        <Listbox.Option
                          key={itemIdx}
                          value={item}
                          className="list-none"
                        >
                          <div
                            className={`flex cursor-pointer items-center gap-x-3 p-2 font-medium ${
                              service.label === item.label
                                ? "bg-bbc-primary text-white"
                                : "hover:bg-bbc-primary hover:bg-opacity-40"
                            }`}
                            onClick={() => setService(item)}
                          >
                            <span className="truncate">{item.label}</span>
                          </div>
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </div>
                </Transition>
              </>
            )}
          </Listbox>
        </div>
        <div className="mb-6">
          <InputText
            as="textarea"
            register={register}
            errors={errors}
            name="message"
            placeholder="Message*"
            requiredText="Message is required"
          />
        </div>
        <div className="flex flex-row flex-wrap items-end justify-between space-y-2">
          <div className="col-12 mb-6 flex items-end justify-center lg:col-7 lg:mb-0 lg:justify-start">
            <div className="inline-block overflow-hidden">
              <ReCaptcha ref={recaptchaRef} className="mx-auto w-max" />
            </div>
          </div>
          <div className="col-12 text-center lg:col-5">
            <ButtonNew
              type="submit"
              id="form-contact-us-button"
              disabled={isLoading}
              othersClass="relative inline-flex justify-center items-center w-full px-2"
              onClick={() => {
                if (isSubmitting) setIsLoading(true);
              }}
            >
              {isSubmitting && (
                <BiLoaderAlt
                  className="mr-2 inline-block animate-spin"
                  size={20}
                />
              )}
              Send Your Message
            </ButtonNew>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Component;

Component.propTypes = {
  locationRouter: PropTypes.string,
  description: PropTypes.string,
  descriptionClass: PropTypes.string,
};

Component.defaultProps = {
  locationRouter: "",
  description: "",
  descriptionClass: "",
};

/** ========== */
